import React, { useEffect, useState } from "react";
import styles from "./SafetyPay.module.css";
import * as Funciones from "../../utils/funciones";
import icon_pacifico from "../../img/icon_pacifico.png";
import icon_safetypay from "../../img/icon_safetypay.png";
import Detalle from "./components/detalle/detalle";
import Bancos from "./components/bancos/bancos";
import Agencias from "./components/agencias/agencias";
import img_sin_info from "../../img/no-informacion.jpg";

const SafetyPay = ({ history, location }) => {
    const initialState = {
        codigo: null,
        fechaVencimiento: null,
        monto: null,
        nombres: null,
        numeroSolicitud: null
    }
    const [ data, setData ] = useState(initialState)
    
    useEffect(() => {
        let json = Funciones.obtenerParamQuery(location.search, 'data')
        if(json !== null) {
            let jsonDecode = Funciones.base64ToJsonDecode(json)
            if(jsonDecode !== null) {
                setData(jsonDecode)
            }
        }
    }, [])

    const handleFormSubmit = (event) => {
        history.push('/login')
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.icon_pacifico}>
                    <img alt="icon_pacifico" src={icon_pacifico} className={styles.img_icon_pacifico} />
                </div>
                <div className={styles.icon_safetypay}>
                    <img alt="icon_safetypay" src={icon_safetypay} className={styles.img_icon_safetypay} />
                </div>
            </div>

            
            {data !== undefined && data !== null && data.numeroSolicitud !== undefined && data.numeroSolicitud !== null
                ? <div className={styles.body}>
                    <div className={styles.detalle}>
                        <Detalle
                            data={data}
                        />
                    </div>
                    <div className={styles.bancos}>
                        <Bancos
                            codigo={data.codigo}
                        />
                    </div>
                    <div className={styles.agencias}>
                        <Agencias
                            codigo={data.codigo}
                        />
                    </div>
                    </div>
                : <div className={`${styles.body} ${styles.no_info}`}>
                    <div className={styles.no_info_img}>
                        <img alt="no disponible" src={img_sin_info} />
                    </div>
                    <div className={styles.no_info_descripcion}>
                        No se encontro información, puede iniciar sesión si así lo desea.
                    </div>
                    <div className={styles.no_info_boton}>
                        <button className={`${styles['jss160']} ${styles['jss134']} ${styles['jss145']}
                            ${styles['jss147']} ${styles['jss159']}`}
                            id="login-button" onClick={handleFormSubmit}>
                                <span className={styles['jss135']}>Entrar</span>
                                <span className={styles['jss163']}></span>
                        </button>
                    </div>
                </div>
            }
            
        </div>
    )
}

export default SafetyPay;